import CodeValueQuery from './code_value_query.vue';

export default CodeValueQuery;
